import cn from "classnames";
import { t } from "i18next";
import { ProductsFieldForForms } from "modules/products";
import { Controller, useFormContext } from "react-hook-form";
import { Input } from "ui";

import {
  AgeField,
  EarningsField,
  GenderField,
  ImageField,
  PostingDateFields,
  RepeatsFields,
  SalesVolumeFields,
  SharesFields
} from "./atoms";
import {
  NotificationFormProps,
  NotificationFormValues
} from "./NotificationForm.types";

import styles from "./NotificationForm.module.scss";

const NotificationForm = ({ formId, onSubmit }: NotificationFormProps) => {
  const { register, handleSubmit, control, formState } =
    useFormContext<NotificationFormValues>();

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.form_notificationBodyFields}>
        <ImageField />

        <Input
          placeholder={t("Enter Title")}
          label={t("Title")}
          {...register("title")}
          errorMessage={formState.errors.title?.message}
        />

        <Input
          asTag="textarea"
          placeholder={t("Enter Description")}
          label={t("Description")}
          {...register("description")}
          errorMessage={formState.errors.description?.message}
        />
      </div>

      <div className={styles.form_separatorLine} />

      <PostingDateFields />

      <RepeatsFields />

      <div className={styles.form_separatorLine} />

      <GenderField />

      <div
        className={cn(
          styles.form_twoColumnsBlock,
          styles.form_twoColumnsBlock__bigGap,
          styles.form_separatedBlock
        )}
      >
        <AgeField />
        <EarningsField />
      </div>

      <SalesVolumeFields />
      <SharesFields />

      <div className={styles.form_separatorLine} />

      <Controller
        control={control}
        name={"productVariants"}
        render={({
          field: { value: productsList, onChange: onChangeProductsList }
        }) => (
          <Controller
            control={control}
            name={"productSet"}
            render={({
              field: { value: productSet, onChange: onChangeProductSet }
            }) => (
              <ProductsFieldForForms
                productsList={productsList}
                onChangeProductsList={onChangeProductsList}
                productSet={productSet}
                onChangeProductSet={onChangeProductSet}
              />
            )}
          />
        )}
      />

      <div className={styles.form_separatorLine} />
    </form>
  );
};

export default NotificationForm;
